export const appsHidStarMenu = [
  {
    text: "Apps Collections",
    target: "/saved-library/collections/",
    img: "/img/screens-grey-icon.svg",
    imgActive: "/img/screens-black-icon.svg",
  },
  {
    text: "Hidden Apps",
    target: "/saved-library/hidden/",
    img: "/img/HideStarPage/HiddenGrey.svg",
    imgActive: "/img/HideStarPage/HiddenBlack.svg",
  },
];

export const screensHidStarMenu = [
  {
    text: "Screens",
    target: "/saved-library/video/",
    img: "/img/screens-grey-icon.svg",
    imgActive: "/img/screens-black-icon.svg",
  },
  {
    text: "Screens Collections",
    target: "/saved-library/groups/",
    img: "/img/groups-grey-icon.svg",
    imgActive: "/img/groups-black-icon.svg",
  },
];
